import { z } from 'my-zod'
import { productLines, ProductLine } from './product-lines'

export const ProductTypeEnum = z.enum(['OffRoad', 'OnRoad', 'Water', 'Snow', 'IMC', 'Pontoon'])
export const ProductTypes = ProductTypeEnum.Values
export type ProductType = z.infer<typeof ProductTypeEnum>

export function GetProductTypeByProductLine(productLine: ProductLine) {
  switch (productLine) {
    case productLines.ACE:
    case productLines.ATV:
    case productLines.GEN:
    case productLines.RGR:
    case productLines.RZR:
      return ProductTypeEnum.Values.OffRoad
    case productLines.SLG:
    case productLines.IND:
      return ProductTypeEnum.Values.OnRoad
    case productLines.SNO:
      return ProductTypes.Snow
    case productLines.PON:
      return ProductTypes.Water
  }
}

export function EvolvedGetProductTypeByProductLine(productLine: ProductLine | 'SXS') {
  switch (productLine) {
    case productLines.ACE:
    case productLines.ATV:
    case productLines.GEN:
    case productLines.RGR:
    case productLines.RZR:
    case 'SXS':
      return ProductTypeEnum.Values.OffRoad
    case productLines.SLG:
      return ProductTypeEnum.Values.OnRoad
    case productLines.IND:
      return ProductTypeEnum.Values.IMC
    case productLines.SNO:
      return ProductTypeEnum.Values.Snow
    case productLines.PON:
      return ProductTypeEnum.Values.Pontoon
  }
}
